import { useContext, useEffect, useState, useRef } from "react";
import { Layout, Model, Actions } from "flexlayout-react";
import {
  Tabs,
  Tab,
  Switch,
  Typography,
  styled,
  Modal,
  Slide,
} from "@mui/material";
import PropTypes from "prop-types";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";

import "flexlayout-react/style/combined.css"; // Dark theme
import Tradeview from "../Trade/Tradeview";
import OrderBook from "../Trade/OrderBook";
import PlaceOrder from "../Trade/Placeorder";
import { Box, Button, Drawer } from "@mui/material";
import Header from "../Header/Header1";
import "./Flexlayout.css";
import Currentorders from "../Trade/currentorders";
import Assetview from "../Trade/AssetView";
import Orderhistory from "../Trade/orderhistory";
import Tradehistorytab from "../Trade/tradehistorytab";
import Subscription from "../Trade/subscription";
import { ThemeContext } from "../DarkMode/ThemeProvider";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { M2 } from "../../SvgCollection";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Grid from "@mui/material/Grid";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import consts from "../../constant";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import usercalls from "../../Axios";
import Context from "../../Context";
import Loader from "../Loader";
import FormControlLabel from "@mui/material/FormControlLabel";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import io from "socket.io-client";
import { toast, ToastContainer } from "react-toastify";
import ImageWithFallback from "../FallbackImage/ImageWithFallback";

const style = {
  position: "absolute",
  top: "12%",
  left: "0%", // Start from the left side of the screen
  transform: "translateY(-50%)", // Center vertically
  width: 600,
  bgcolor: "var(--model)",
  // border: '2px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 2,
  "@media (max-width: 767.98px)": {
    width: "90% !important",
    left: "0%",
  },
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 18,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    left: "2px",
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#566FFF",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 14,
    height: 13,
    left: "2px",
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "#ccc",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: "2px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

var jsonProfessional = {
  global: {},
  borders: [],
  layout: {
    type: "column",
    weight: 100,
    children: [
      {
        type: "row",
        weight: 85,
        children: [
          {
            type: "column",
            weight: 100,
            children: [
              {
                type: "tabset",
                weight: 80,
                // minWidth:  300,
                minHeight: 500,
                children: [
                  {
                    type: "tab",
                    name: "Chart",
                    component: "Tradeview",
                    id: "tab1",
                  },
                ],
              },
              {
                type: "tabset",
                minWidth: 300,
                weight: 20,
                children: [
                  {
                    type: "tab",
                    name: "Order Book",
                    component: "OrderBook",
                    id: "tab2",
                  },
                ],
              },
            ],
          },
          {
            type: "column",
            weight: 100,
            children: [
              {
                type: "tabset",
                weight: 20,
                children: [
                  {
                    type: "tab",
                    name: `Current Order()`,
                    component: "Current Order",
                    id: "tab3",
                  },
                  {
                    type: "tab",
                    name: "Order History",
                    component: "Order History",
                    id: "tab4",
                  },
                  {
                    type: "tab",
                    name: "Trade History",
                    component: "Trade History",
                    id: "tab5",
                  },
                  // {
                  //   type: "tab",
                  //   name: "Redemption History",
                  //   component: "Redemption History",
                  //   id: "tab6",
                  // },
                ],
              },
            ],
          },
        ],
      },
      {
        type: "row",
        weight: 15,

        children: [
          {
            type: "row",
            weight: 100,
            children: [
              {
                type: "tabset",
                weight: 100,
                minHeight: 500,
                minWidth: 300,
                children: [
                  {
                    type: "tab",
                    name: "Place Order",
                    component: "PlaceOrder",
                    id: "tab7",
                  },
                ],
              },
            ],
          },
          {
            type: "row",
            weight: 100,
            children: [
              {
                type: "tabset",
                weight: 100,
                children: [
                  {
                    type: "tab",
                    name: "Assetview",
                    component: "Assetview",
                    id: "tab8",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

var jsonClassic = {
  global: {},
  borders: [],
  layout: {
    type: "column",
    weight: 100,
    children: [
      {
        type: "row",
        weight: 20,
        children: [
          {
            type: "column",
            weight: 100,

            children: [
              {
                type: "tabset",
                //   weight: 30,
                minHeight: 500,
                minWidth: 275,
                children: [
                  {
                    type: "tab",
                    name: "Markets",
                    component: "Markets",
                    id: "tab1",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        type: "row",
        weight: 60,
        children: [
          {
            type: "row",
            weight: 100,
            children: [
              {
                type: "tabset",
                weight: 100,
                minHeight: 300,
                minWidth: 350,
                children: [
                  {
                    type: "tab",
                    name: "Chart",
                    component: "Tradeview",
                    id: "tab2",
                  },
                ],
              },
            ],
          },
          {
            type: "row",
            weight: 100,
            children: [
              {
                type: "tabset",
                weight: 100,
                children: [
                  {
                    type: "tab",
                    name: "PlaceOrder",
                    component: "PlaceOrder",
                    id: "tab3",
                  },
                  {
                    type: "tab",
                    name: "Current Order",
                    component: "Current Order",
                    id: "tab4",
                  },
                  {
                    type: "tab",
                    name: "Order History",
                    component: "Order History",
                    id: "tab5",
                  },
                  {
                    type: "tab",
                    name: "Trade History",
                    component: "Trade History",
                    id: "tab6",
                  },
                  // {
                  //   type: "tab",
                  //   name: "Redemption History",
                  //   component: "Redemption History",
                  //   id: "tab7",
                  // },
                ],
              },
            ],
          },
        ],
      },
      {
        type: "row",
        weight: 20,
        children: [
          {
            type: "column",
            weight: 100,
            children: [
              {
                type: "tabset",
                //   weight: 30,
                minWidth: 275,
                minHeight: 500,
                children: [
                  {
                    type: "tab",
                    name: "Order Book",
                    component: "OrderBook",
                    id: "tab8",
                  },
                ],
              },
            ],
          },
          {
            type: "column",
            weight: 100,
            children: [
              {
                type: "tabset",
                children: [
                  {
                    type: "tab",
                    name: "Assetview",
                    component: "Assetview",
                    id: "tab9",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

var jsonFullscreen = {
  global: {},
  borders: [],
  layout: {
    type: "column",
    weight: 100,
    children: [
      {
        type: "row",
        weight: 70,
        children: [
          {
            type: "row",
            weight: 100,
            children: [
              {
                type: "tabset",
                // weight: 100,
                minWidth: 400,
                minHeight: 300,
                children: [
                  {
                    type: "tab",
                    name: "Chart",
                    component: "Tradeview",
                    id: "tab1", // 🔥 Added ID
                  },
                ],
              },
            ],
          },
          {
            type: "row",
            weight: 100,
            children: [
              {
                type: "tabset",
                weight: 100,
                children: [
                  {
                    type: "tab",
                    name: "Current Order",
                    component: "Current Order",
                    id: "tab2", // 🔥 Added ID
                  },
                  {
                    type: "tab",
                    name: "Order History",
                    component: "Order History",
                    id: "tab3", // 🔥 Added ID
                  },
                  {
                    type: "tab",
                    name: "Trade History",
                    component: "Trade History",
                    id: "tab4", // 🔥 Added ID
                  },
                  // {
                  //   type: "tab",
                  //   name: "Redemption History",
                  //   component: "Redemption History",
                  //   id: "tab5", // 🔥 Added ID
                  // },
                ],
              },
            ],
          },
        ],
      },
      {
        type: "row",
        weight: 30,
        children: [
          {
            type: "column",
            weight: 100,

            children: [
              {
                type: "tabset",
                minWidth: 400,
                // height: 150,
                children: [
                  {
                    type: "tab",
                    name: "Order Book",
                    component: "OrderBook",
                    id: "tab6", // 🔥 Added ID
                  },
                ],
              },
            ],
          },
          {
            type: "column",
            weight: 100,

            children: [
              {
                type: "tabset",
                children: [
                  {
                    type: "tab",
                    name: "Place Order",
                    component: "PlaceOrder",
                    id: "tab7", // 🔥 Added ID
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

// const model = Model.fromJson(localStorage.getItem("layout") === 'classic' ?  jsonClassic : jsonProfessional);

const Flexlayout = () => {
  const containerRef = useRef(null);
  const theme = useTheme();
  const { id } = useParams();

  //open orders count
  const {
    currentOrders,
    setPointFilter,
    kucoinSocket,
    spotConnected,
    setOrderBookBits,
    setOrderBookAsks,
    activeTabId,
    setActiveTabId,
    setMarkPrice
  } = useContext(Context);
  const path = usercalls();
  const loaction = useLocation();
  const navigate = useNavigate();
  const placeRoute = loaction.pathname?.split("/")[1];
  const searchDebounceTimeout = useRef(null);
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  const mobilemd = useMediaQuery(theme.breakpoints.up("md"));
  const matchesXL = useMediaQuery(theme.breakpoints.up("lg"));

  const [value, setValue] = useState(0);
  const [load, setLoad] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [defLayout, setDefLayout] = useState("professional");
  const [professional, setProfessional] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const [classic, setClassic] = useState(false);

  const [currentPair, setCurrentPair] = useState();
  const [pairsList, setPairsList] = useState([]);
  const [originalPairsList, setOriginalPairsList] = useState([]);
  const [marketList, setMarketList] = useState(["USDT", "USDC", "BTC", "KCS"]);
  const [pairsLoading, setPairsLoading] = useState(false);
  const [candle, setCandle] = useState(false);

  function formatNumber(num) {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2) + "M"; // Convert to Million
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(2) + "K"; // Convert to Thousand
    } else {
      return num.toString(); // Return as is if < 1,000
    }
  }

  let lastUpdateTime = 0;

  const handleCandle = () => {
    setCandle(!candle);
  };

  const layouts = {
    classic: jsonClassic,
    professional: jsonProfessional,
    fullscreen: jsonFullscreen,
  };

  const {
    setOpenPositions,
    setOpenPositionsData,
    setCurrentOrders,
    setCurrentOrdersData,
    setBalanceUpdate,
  } = useContext(Context);

  const openOrderSocket = async () => {
    try {
      setLoad(true);
      var socket = "";
      if (consts?.type == "Production") {
        socket = io(`${consts?.socketUrl}`, { path: "/socket" }); // for Live
      } else {
        socket = io(`${consts?.socketUrl}`); // for local
      }

      socket.on("connect", () => {
        const request = {
          userId: localStorage.getItem("use"),
          type: placeRoute,
        };
        // console.log(request, "requestrequest");
        socket.emit("getOpenOrders", request);
      });

      socket.on("getOpenOrders", (data) => {
        if (data?.success) {
          setOpenPositionsData(data?.position);
          setCurrentOrdersData(data?.data);
          setOpenPositions(data?.position?.length ? data?.position?.length : 0);
          setCurrentOrders(data?.data?.length ? data?.data?.length : 0);
          setBalanceUpdate(Math.random(6));
        } else {
          setOpenPositionsData([]);
          setOpenPositions(0);
          console.log("Error:", data?.message);
        }
      });
      socket.on("disconnect", () => {
        console.log("Disconnected from backend WebSocket");
      });
      setLoad(false);
    } catch (error) {
      console.log("🚀 ~ getOpenOrdersSocket ~ error:", error);
      setLoad(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("use")) {
      openOrderSocket();
    }
  }, []);

  const [model, setModel] = useState(Model.fromJson(layouts[defLayout]));
  const [tabsVisibility, setTabsVisibility] = useState({});

  // Extract all tab IDs dynamically from the selected layout
  const extractTabIds = (layout) => {
    const tabIds = {};

    const traverse = (node) => {
      if (node.type === "tab") {
        tabIds[node.id] = true; // Default visibility to true
      } else if (node.children) {
        node.children.forEach(traverse);
      }
    };

    traverse(layout.layout);
    return tabIds;
  };

  // Update tabsVisibility when layout changes
  useEffect(() => {
    const newLayout = layouts[defLayout];
    setModel(Model.fromJson(newLayout));
    setTabsVisibility(extractTabIds(newLayout));
  }, [defLayout]);

  // Toggle tab visibility dynamically
  const toggleTab = (tabId) => {
    setTabsVisibility((prev) => {
      const newVisibility = { ...prev, [tabId]: !prev[tabId] };
      updateModel(newVisibility);
      return newVisibility;
    });
  };

  // Update the model when a tab is hidden or shown
  const updateModel = (visibility) => {
    const newJson = JSON.parse(JSON.stringify(layouts[defLayout]));

    const filterTabs = (node) => {
      if (node.type === "tabset") {
        return {
          ...node,
          children: node.children.filter((tab) => visibility[tab.id] !== false),
        };
      } else if (node.children) {
        return {
          ...node,
          children: node.children.map(filterTabs),
        };
      }
      return node;
    };

    newJson.layout = filterTabs(newJson.layout);
    setModel(Model.fromJson(newJson));
  };

  const findTabName = (tabId) => {
    let tabName = "Unknown Tab";

    const traverse = (node) => {
      if (node.type === "tab" && node.id === tabId) {
        tabName = node.name;
      } else if (node.children) {
        node.children.forEach(traverse);
      }
    };

    traverse(layouts[defLayout].layout);
    return tabName;
  };

  // Handle tab close event from FlexLayout
  const handleLayoutAction = (action) => {
    if (action.type === "FlexLayout_DeleteTab") {
      const closedTabId = action.data.node;
      if (closedTabId === activeTabId) {
        setActiveTabId(null);
      }

      setTabsVisibility((prev) => ({
        ...prev,
        [closedTabId]: false, // Hide tab when closed
      }));
      updateModel({ ...tabsVisibility, [closedTabId]: false });
    }

    if (action.type === "FlexLayout_SelectTab") {
      const nodeId = action.data.tabNode; // this is just "tab5", "tab6", etc.
      setActiveTabId(nodeId);
    }
    return action;
  };

  const restoreDefaultTabs = () => {
    const originalLayout = layouts[defLayout];
    // console.log(originalLayout, "originalLayout");

    const restoredVisibility = extractTabIds(originalLayout); // sets all to true
    setTabsVisibility(restoredVisibility);
    setModel(Model.fromJson(originalLayout));
  };

  const { isLightMode } = useContext(ThemeContext);

  const [openLayout, setOpenLayout] = useState(false);
  const toggleDrawerLayout = (newOpen) => () => {
    setOpenLayout(newOpen);
  };
  const [openCoinPair, setOpenCoinPair] = useState(false);
  const handleOpenCoinPair = (val) => {
    setOpenCoinPair(true);
  };

  const handleCloseCoinPair = () => {
    setOpenCoinPair(false);
  };

  const handleLayoutType = (type) => {
    localStorage.setItem("layout", type);

    if (type === "professional") {
      setProfessional(true);
      setFullScreen(false);
      setClassic(false);
    } else if (type === "fullscreen") {
      setProfessional(false);
      setFullScreen(true);
      setClassic(false);
    } else if (type === "classic") {
      setProfessional(false);
      setFullScreen(false);
      setClassic(true);
    }
  };

  useEffect(() => {
    const savedLayout = localStorage.getItem("layout");

    if (savedLayout) {
      // Above 1199px, restore saved layout
      setDefLayout(savedLayout);
      handleLayoutType(savedLayout);
    }

    // console.log('matchesXL');
  }, [mobilemd]);

  const [valueTab2, setValueTab2] = useState(0);
  const [quoteCoin, setQuoteCoin] = useState("");
  const [type, setType] = useState("spot");

  const [value7, setValue7] = useState(0);

  const handleChange7 = (event, newValue) => {
    setValue7(newValue);
    setQuoteCoin(marketList[newValue]);
  };

  const handleChangeTab2 = (event, newValue) => {
    const tabLabels = ["spot", "future", "spot"];
    setValueTab2(newValue);
    setType(tabLabels[newValue]);
  };

  function countDecimals(num) {
    window.filterPoint = num;
    window.localStorage.setItem("pointFilter", num);
    return num;
  }

  useEffect(() => {
    window.filterPoint = window.localStorage.getItem("pointFilter");
  }, []);

  const handleSearch = async (search) => {
    if (searchDebounceTimeout.current) {
      clearTimeout(searchDebounceTimeout.current);
    }

    searchDebounceTimeout.current = setTimeout(() => {
      fetchPairsList(search);
    }, 500);
  };


  useEffect(() => {
    if (model) {
      model.doAction(
        Actions.renameTab("tab3", `Current Order(${currentOrders})`)
      );
    }
  }, [model, currentOrders]);

  const fetchPairsList = async (search, type, quot) => {
    try {
      setPairsList([]);
      setPairsLoading(true);
      var url;
      if (placeRoute == "future") {
        url = `${consts.BackendUrl}/getOwnFuturePairs?search=${search ? search : ""
          }`;
      } else {
        url = `${consts.BackendUrl}/getOwnPairs?type=${quot ? quot : quoteCoin}&search=${search ? search : ""
          }`;
      }

      const response = await path.getCall({ url });
      const result = await response.json();
      if (result?.success == true) {

        setPairsList(result?.result);
        if (type == "runs") {
          setOriginalPairsList(result?.result);
          handleSidebarSubscribe(result?.result);
        }
        setMarketList(result?.marketPair);
        result?.result?.forEach((pair) => {
          const symbol = pair.pair_symbol?.split("_").join("");
          if (pair?.pair_symbol === id) {
            $(`.prices-${symbol}`).html(
              `<span >${Number(pair?.last).toFixed(
                window.filterPoint ? window.filterPoint : 2
              )}</span>`
            );

            $(`.pricesses-${symbol}`).html(
              `<span > ${Number(pair?.last).toFixed(
                window.filterPoint ? window.filterPoint : 2
              )}</span>`
            );

            $(`.24hp-${symbol}`).html(
              `<span class=${Number(pair?.changeRate * 100).toFixed(2) > 0
                ? "tr-green"
                : "tr-red"
              } >${Number(pair?.changeRate * 100).toFixed(2)}</span>`
            );
            $(`.24hpc-${symbol}`).html(
              `<span class=${Number(pair?.changeRate * 100).toFixed(2) > 0
                ? "tr-green"
                : "tr-red"
              } >${Number(pair?.changeRate * 100).toFixed(2) + "%"}</span>`
            );
            $(`.vol-${symbol}`).html(Number(pair?.vol).toFixed(2));
            $(`.volbase-${symbol}`).html(Number(pair?.vol).toFixed(2));
            $(`.high-${symbol}`).html(
              Number(pair?.high)
            );
            $(`.low-${symbol}`).html(
              Number(pair?.low).toFixed(
                window.filterPoint ? window.filterPoint : 2
              )
            );
          }
        });
      } else {
        setPairsList([]);
      }
      setPairsLoading(false);
    } catch (error) {
      setPairsLoading(false);
      console.log("🚀 ~ fetchPairsList ~ error:", error);
    }
  };

  useEffect(() => {
    if (quoteCoin) {
      handleSidebarUnsubscribe();
      fetchPairsList("", "runs");
    }
  }, [quoteCoin]);

  const marketData = (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ margin: "0" }}>
        <Tabs
          value={valueTab2}
          onChange={handleChangeTab2}
          aria-label="basic tabs example"
          className="tabs-trade"
        >
          <Tab label="spot" {...a11yProps(0)} />
          {/* <Tab label="Margin" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab2} index={0}>
        <Box sx={{ width: "100%" }}>
          <Box>
            <Tabs
              value={value7}
              onChange={handleChange7}
              aria-label="basic tabs example"
              className="tabs-trade"
            >
              {marketList?.map((row, i) => {
                return <Tab label={row} {...a11yProps(i)} key={i} />;
              })}
            </Tabs>
          </Box>

          <CustomTabPanel className="cust-box">
            <TableContainer
              className="trade-left-table model"
              sx={{ overflowY: "scroll", height: "100vh" }}
            >
              <Table aria-label="simple table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left"> Trading Pairs/Vol </TableCell>
                    <TableCell align="right">Price /24H Change</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pairsList?.length > 0 &&
                    pairsList?.map((row, ind) => (
                      <TableRow
                        key={ind}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        onClick={() => {
                          navigate(
                            `/${placeRoute}/${row?.base_asset_name}_${row?.market_asset_name}`
                          );
                          setPointFilter(countDecimals(row?.pointFilter));
                          handleCloseCoinPair();
                          handleSidebarUnsubscribe();
                          handleSearch("");
                        }}
                      >
                        <TableCell component="th" scope="row" align="left">
                          <div
                            className="select-form display-1 cursor"
                            onClick={() => {
                              handleOpenCoinPair();
                              localStorage.setItem("pairUrl", row?.imageurl);
                            }}
                          >

                            <ImageWithFallback
                              src={
                                row?.imageurl
                                  ? row?.imageurl
                                  : `${consts?.imageurl}${row?.base_asset_name}.png`
                              }
                              name={row?.base_asset_name}
                              alt="img"
                            />

                            <div>
                              {row?.base_asset_name}/
                              <span style={{ color: "#706c6c" }}>
                                {row?.market_asset_name}
                              </span>
                            </div>

                          </div>
                        </TableCell>

                        <TableCell component="th" scope="row" align="right">
                          <span
                            className={`price-${row?.pair_symbol
                              ?.split("_")
                              ?.join("")}`}
                          >
                            {Number(row?.last)}
                          </span>
                          <div
                            className={`24hrchange-${row?.pair_symbol
                              ?.split("_")
                              ?.join("")} mt-5 ${Number(row?.changeRate) >= 0
                                ? "tr-green"
                                : "tr-red"
                              }`}
                          >
                            {Number(row?.changeRate).toFixed(2)} %
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  {pairsLoading == true ? (
                    <TableRow>
                      <TableCell colSpan={8}>
                        <div className="model-load">
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    pairsList?.length == 0 && (
                      <TableRow>
                        <TableCell colSpan={8}>
                          <div
                            className="model-load"
                            style={{ color: "white", textAlign: "center" }}
                          >
                            No Pair Found
                          </div>
                        </TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        </Box>
      </CustomTabPanel>
    </Box>
  );

  // Restore a closed tab

  const DrawerList = (
    <Box
      sx={{ width: 420, p: 1 }}
      role="presentation"
      onClick={toggleDrawerLayout(false)}
    >
      <Box marginBottom={0} sx={{ p: 1, borderBottom: "1px solid #cccccc36" }}>
        <div className="display-2 p-10">
          <div
            className="select-form x2"
            style={{ fontSize: "16px !important" }}
          >
            Layout
          </div>
          <div className="display-1">
            <HighlightOffIcon
              sx={{ fontSize: "25px !important" }}
              className="cursor"
              onClick={toggleDrawerLayout(false)}
            />
          </div>
        </div>
      </Box>
      <div
        className="p-10 mt-20"
        style={{ borderBottom: "1px solid #cccccc36" }}
      >
        <div className="deflayout-h">Default Layout</div>
        <div className="display-3 flex-wrap def-lay-svg">
          <div
            className={
              defLayout === "classic" ? "svg-actv class-name" : "class-name"
            }
            onClick={() => {
              setDefLayout("classic");
              handleLayoutType("classic");
            }}
          >
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="classic-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="34"
                y="40"
                width="60"
                height="29"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="65"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="47"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Classic</div>
          </div>

          <div
            className={
              defLayout === "professional"
                ? "svg-actv class-name"
                : "class-name"
            }
            onClick={() => {
              setDefLayout("professional");
              handleLayoutType("professional");
            }}
          >
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="advanced-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="91"
                y="11"
                width="26"
                height="58"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="96"
                y="16"
                width="7"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
              <rect
                x="105"
                y="16"
                width="7"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="96"
                y="44"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Professional</div>
          </div>

          <div
            className={
              defLayout === "fullscreen" ? "svg-actv class-name" : "class-name"
            }
            onClick={() => {
              setDefLayout("fullscreen");
              handleLayoutType("fullscreen");
            }}
          >
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="fullscreen-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="69"
                y="40"
                width="48"
                height="29"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="94"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="76"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Full Screen</div>
          </div>
        </div>
        <div className="deflayout-h mt-20">Custom Layout</div>
        <div className="  def-lay-svg ">
          <div
            className={"custm-lay"}
            onClick={() => toast.success("Under Development")}
          >
            <div className="cust-svg">
              <AddCircleOutlineIcon sx={{ color: "#cccccc36" }} />
            </div>
            <div className="class-name mt-10">Create</div>
          </div>
        </div>
      </div>

      <div className="p-10 mt-20">
        <div className="display-2">
          <div className="deflayout-h" style={{ textTransform: "capitalize" }}>
            {defLayout}
          </div>
          <div
            className="deflayout-h cursor"
            style={{ textTransform: "capitalize", color: "#566FFF" }}
            onClick={() => {
              restoreDefaultTabs();
            }}
          >
            Restore to Default
          </div>
        </div>
      </div>

      <div style={{ marginBottom: "10px" }}>
        {Object.keys(tabsVisibility).map((tabId) => {
          const tabName = findTabName(tabId); // Get tab name dynamically
          return (
            <div key={tabId} className="p-10">
              <FormControlLabel
                labelPlacement="start"
                label={tabName}
                control={
                  <AntSwitch
                    checked={tabsVisibility[tabId]}
                    onChange={() => toggleTab(tabId)}
                  />
                }
                sx={{
                  justifyContent: "space-between",
                  width: "100%",
                  color: "var(--clr-font)",
                  ml: 0,
                }}
              />
            </div>
          );
        })}
      </div>
    </Box>
  );

  const prevIdRef = useRef("");

  useEffect(() => {
    if (!spotConnected || !kucoinSocket?.current) return;

    const prevId = prevIdRef.current;
    const mergeCurrent = id.split("_").join("-").toUpperCase();
    const currentTopic = `/market/snapshot:${mergeCurrent}`;

    const unsubscribeTopic = (symbolId) => {
      if (symbolId && kucoinSocket.current?.readyState === WebSocket.OPEN) {
        const formatted = symbolId.split("_").join("-").toUpperCase();
        const topic = `/market/snapshot:${formatted}`;
        const msg = {
          id: Date.now(),
          type: "unsubscribe",
          topic,
          response: true,
        };
        kucoinSocket.current.send(JSON.stringify(msg));
        console.log("🛑 Unsubscribed:", topic);
      }
    };

    const subscribeTopic = () => {
      if (kucoinSocket.current?.readyState === WebSocket.OPEN) {
        const msg = {
          id: Date.now(),
          type: "subscribe",
          topic: currentTopic,
          response: true,
        };
        kucoinSocket.current.send(JSON.stringify(msg));
        console.log("✅ Subscribed:", currentTopic);
      }
    };

    const handleMessage = (event) => {
      const res = JSON.parse(event.data);
      const json = res?.data ?? null;
      const topic = res?.topic;

      if (!json || !topic) return;

      const symbol = topic.split(":")[1].replace(/-/g, "");
      // console.log("🚀 ~ handleMessage ~ symbol:", symbol)

      if (json?.asks && json?.bids) {
        const now = Date.now();
        const oneSecond = 1000;
        // Only process if 1 second has passed since last update
        if (now - lastUpdateTime >= oneSecond) {
          lastUpdateTime = now;
          var bits = json?.asks;
          var asks = json?.bids;
          const updatedBits = bits?.map(([price, quantity]) => {
            const total = parseFloat(price) * parseFloat(quantity);
            return [
              price,
              quantity,
              total,
              formatNumber(parseFloat(quantity)),
              formatNumber(total.toFixed(3)),
            ];
          });
          if (bits?.length > 0) {
            setOrderBookBits((prevArray) => {
              // Concatenate the previous array with the new bits, sort in descending order, and slice the first 20 elements
              const updatedArray = [...updatedBits, ...prevArray]
                .slice(0, 20)
                .sort((a, b) => parseFloat(b[0]) - parseFloat(a[0]));
              return updatedArray;
            });
          }
          const updatedAsks = asks?.map(([price, quantity]) => {
            const total = parseFloat(price) * parseFloat(quantity);
            return [
              price,
              quantity,
              total,
              formatNumber(parseFloat(quantity)),
              formatNumber(total.toFixed(3)),
            ];
          });
          if (asks?.length > 0) {
            setOrderBookAsks((prevArray) => {
              // Concatenate the previous array with the new asks, sort in descending order, and slice the first 20 elements
              const updatedArray = [...updatedAsks, ...prevArray].slice(0, 20);
              return updatedArray;
            });
          }

          // ✅ Do something with the data here
          // console.log('Processed WebSocket data:');
        }
      } else {
        $(`.price-${res?.topic?.split(":")[1].split("-").join("")}`).html(
          `<span  > ${Number(json?.data?.lastTradedPrice)} </span>`
        );
        $(`.24hrchange-${res?.topic?.split(":")[1].split("-").join("")}`).html(
          `<span class=${Number(json?.data?.changeRate * 100).toFixed(2) >= 0
            ? "tr-green"
            : "tr-red"
          } >${Number(json?.data?.changeRate * 100).toFixed(2) + "%"}</span>`
        );

        $(`.prices-${json?.data?.symbol.split("-").join("")}`).html(
          `<span  >${Number(json?.data?.lastTradedPrice).toFixed(
            window.filterPoint ? window.filterPoint : 2
          )}</span>`
        );

        $(`.pricesses-${json?.data?.symbol.split("-").join("")}`).html(
          `<span > ${Number(json?.data?.lastTradedPrice).toFixed(
            window.filterPoint ? window.filterPoint : 2
          )}</span>`
        );

        $(`.24hpc-${json?.data?.symbol.split("-").join("")}`).html(
          `<span class=${Number(json?.data?.changeRate * 100).toFixed(2) > 0
            ? "tr-green"
            : "tr-red"
          } >${Number(json?.data?.changeRate * 100).toFixed(2) + "%"}</span>`
        );

        $(`.volbase-${json?.data?.symbol.split("-").join("")}`).html(
          Number(json?.data?.marketChange24h?.vol).toFixed(2)
        );

        $(`.high-${json?.data?.symbol.split("-").join("")}`).html(
          Number(json?.data?.high)
        );

        $(`.low-${json?.data?.symbol.split("-").join("")}`).html(
          Number(json?.data?.low)
        );

        if (json.data?.lastTradedPrice) {
          setMarkPrice(json.data?.lastTradedPrice);
        }
      }

      // Update UI (jQuery or React)
    };

    kucoinSocket.current.onmessage = handleMessage;

    if (kucoinSocket.current.readyState === WebSocket.OPEN) {
      unsubscribeTopic(prevId); // unsubscribe old
      subscribeTopic(); // subscribe new
    } else {
      kucoinSocket.current.onopen = () => {
        unsubscribeTopic(prevId);
        subscribeTopic();
      };
    }

    prevIdRef.current = id;

    return () => {
      // Always unsubscribe current topic on unmount
      unsubscribeTopic(id);

      // Cleanup handlers
      if (kucoinSocket.current) {
        kucoinSocket.current.onopen = null;
        kucoinSocket.current.onmessage = null;
        kucoinSocket.current.onerror = null;
        kucoinSocket.current.onclose = null;
      }
    };
  }, [spotConnected, id, kucoinSocket.current]);

  const sidebarSubscribedRef = useRef(false);

  const handleSidebarSubscribe = (pairsList) => {
    if (
      !kucoinSocket.current ||
      kucoinSocket.current.readyState !== WebSocket.OPEN
    )
      return;
    if (sidebarSubscribedRef.current) return; // already subscribed

    const symbols = pairsList
      .map((pair) => pair.pair_symbol?.split("_").join("-").toUpperCase())
      .join(",");

    const topic = `/market/snapshot:${symbols}`;
    const subscribeMsg = {
      id: Date.now(),
      type: "subscribe",
      topic,
      response: true,
    };

    kucoinSocket.current.send(JSON.stringify(subscribeMsg));
    console.log("📡 Subscribed to sidebar pairs123:", topic);
    sidebarSubscribedRef.current = true;
  };

  const handleSidebarUnsubscribe = () => {
    if (
      !kucoinSocket.current ||
      kucoinSocket.current.readyState !== WebSocket.OPEN
    )
      return;
    if (!sidebarSubscribedRef.current) return; // already unsubscribed

    const currentSymbol = id?.split("_")?.join("-")?.toUpperCase();
    console.log("🚀 ~ handleSidebarUnsubscribe ~ currentSymbol:", currentSymbol)

    const symbols = originalPairsList
      ?.filter(
        (pair) =>
          pair.pair_symbol?.split("_")?.join("-")?.toUpperCase() !==
          currentSymbol
      )
      ?.map((pair) => pair.pair_symbol?.split("_")?.join("-")?.toUpperCase())
      ?.join(",");

    const topic = `/market/snapshot:${symbols}`;
    const unsubscribeMsg = {
      id: Date.now(),
      type: "unsubscribe",
      topic,
      response: true,
    };

    kucoinSocket.current.send(JSON.stringify(unsubscribeMsg));
    console.log("🛑 Unsubscribed from sidebar pairs:", topic);
    sidebarSubscribedRef.current = false;
  };

  useEffect(() => {
    const newModel = Model.fromJson(
      defLayout === "classic"
        ? jsonClassic
        : defLayout === "professional"
          ? jsonProfessional
          : jsonFullscreen
    );
    setModel(newModel); // ✅ Update state
  }, [defLayout]);

  // Apply theme dynamically
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.className = isLightMode
        ? "flexlayout__theme_light"
        : "flexlayout__theme_dark";
    }
  }, [isLightMode]);

  const factory = (node) => {
    const component = node.getComponent();

    const panelWrapper = (content) => (
      <div style={{ height: "100%" }}>{content}</div>
    );

    if (component === "Tradeview") {
      return panelWrapper(
        load ? (
          <div className="inline-loader trd">
            <Loader />
          </div>
        ) : (
          <Tradeview />
        )
      );
    } else if (component === "OrderBook") {
      return panelWrapper(
        // load ? (
        //   <div className="inline-loader trd">
        //     <Loader />
        //   </div>
        // ) : (
        <OrderBook />
        // )
      );
    } else if (component === "PlaceOrder") {
      return panelWrapper(
        load ? (
          <div className="inline-loader trd">
            <Loader />
          </div>
        ) : (
          <PlaceOrder />
        )
      );
    } else if (component === "Current Order") {
      return panelWrapper(
        load ? (
          <div className="inline-loader trd">
            <Loader />
          </div>
        ) : (
          <Currentorders />
        )
      );
    } else if (component === "Order History") {
      return panelWrapper(
        load ? (
          <div className="inline-loader trd">
            <Loader />
          </div>
        ) : (
          <Orderhistory />
        )
      );
    } else if (component === "Trade History") {
      return panelWrapper(
        load ? (
          <div className="inline-loader trd">
            <Loader />
          </div>
        ) : (
          <Tradehistorytab />
        )
      );
    } else if (component === "Redemption History") {
      return panelWrapper(
        load ? (
          <div className="inline-loader trd">
            <Loader />
          </div>
        ) : (
          <Subscription />
        )
      );
    } else if (component === "Assetview") {
      return panelWrapper(
        load ? (
          <div className="inline-loader trd">
            <Loader />
          </div>
        ) : (
          <Assetview />
        )
      );
    } else if (component === "Markets") {
      return panelWrapper(marketData);
    }

    return <div>Unknown Component</div>;
  };

  const getSinglePairDetails = async (id) => {
    try {
      setLoad(true);
      var url;
      if (placeRoute == "future") {
        url = `${consts.BackendUrl}/getOwnFuturePairs`;
      } else {
        url = `${consts.BackendUrl}/getOwnSinglePair`;
      }

      var payload = {
        pair: id,
        type: "spot",
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {

        $(`.prices-${result?.result?.symbol?.split("-").join("")}`).html(
          `<span  >${Number(result?.result?.last).toFixed(
            window.filterPoint ? window.filterPoint : 2
          )}</span>`
        );
        setMarkPrice(
          Number(result?.result?.last).toFixed(
            window.filterPoint ? window.filterPoint : 2
          )
        );

        $(`.pricesses-${result?.result?.symbol?.split("-").join("")}`).html(
          `<span > ${Number(result?.result?.last).toFixed(
            window.filterPoint ? window.filterPoint : 2
          )}</span>`
        );

        $(`.24hpc-${result?.result?.symbol?.split("-").join("")}`).html(
          `<span class=${Number(result?.result?.changeRate * 100).toFixed(2) > 0
            ? "tr-green"
            : "tr-red"
          } >${Number(result?.result?.changeRate * 100).toFixed(2) + "%"
          }</span>`
        );

        $(`.volbase-${result?.result?.symbol?.split("-").join("")}`).html(
          Number(result?.result?.vol).toFixed(2)
        );

        $(`.high-${result?.result?.symbol?.split("-").join("")}`).html(
          Number(result?.result?.high)
        );

        $(`.low-${result?.result?.symbol?.split("-").join("")}`).html(
          Number(result?.result?.low)
        );
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log("🚀 ~ getSinglePairDetails ~ error:", error);
      setLoad(false);
    }
  };

  useEffect(() => {
    setCurrentPair(id);
    getSinglePairDetails(id);
  }, [id]);

  return (
    <div>
      <Box sx={{ width: "100%", marginTop: "45px" }}>
        <ToastContainer />
        <Header />
        <Drawer
          anchor="right"
          open={openLayout}
          onClose={toggleDrawerLayout(false)}
          className="layout-draw"
        >
          {DrawerList}
        </Drawer>
        <Grid container className="stick">
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="padding-10 grid-box x2">
              <div className="display-2">
                <div
                  className="display-1"
                  style={{
                    gap: !mobilemd ? "20px" : "40px",
                    overflowY: !mobilemd && "scroll",
                    paddingLeft: mobilemd ? "15px" : "0px",
                  }}
                >
                  <div
                    className="select-form display-1 cursor"
                    onClick={() => {
                      handleOpenCoinPair();
                      fetchPairsList("", "runs", "USDT");
                      setQuoteCoin("USDT")
                    }}
                  >

                    {currentPair && (
                      <ImageWithFallback
                        src={`${consts?.imageurl}${currentPair?.split("_")[0]
                          }.png`}
                        alt="Btcoin"
                        name={`${currentPair?.split("_")[0]}`}
                        className="Btcoin"
                      />
                    )}

                    <div>{currentPair?.split("_")?.join("/")}</div>
                    {defLayout !== "classic" && (
                      <ArrowDropDownCircleOutlinedIcon sx={{ fontSize: "20px !important" }} />
                    )}
                  </div>
                  <div
                    className="display-5"
                    style={{
                      gap: "30px",
                      width: "auto",
                      overflowY: !sm && "scroll",
                      marginLeft: "15px",
                    }}
                  >
                    <div className="total-data">
                      Price
                      <div className="total-sub">
                        <span
                          className={`prices-${currentPair
                            ?.split("_")
                            ?.join("")}`}
                        >
                          0
                        </span>
                        <span> {currentPair?.split("_")[1]}</span>
                      </div>
                    </div>

                    <div className="lh-24">
                      24h change
                      <div className="lh-sub" style={{ color: "#f66754" }}>
                        <span
                          className={`24hpc-${currentPair
                            ?.split("_")
                            ?.join("")}`}
                        >
                          0
                        </span>
                      </div>
                    </div>
                    <div className="lh-24">
                      24h High
                      <div className="lh-sub">
                        <span
                          className={`high-${currentPair
                            ?.split("_")
                            ?.join("")}`}
                        >
                          0
                        </span>
                      </div>
                    </div>

                    <div className="lh-24">
                      24h Low
                      <div className="lh-sub">
                        <span
                          className={`low-${currentPair?.split("_")?.join("")}`}
                        >
                          0
                        </span>
                      </div>
                    </div>

                    <div className="lh-24">
                      24h volume ({currentPair?.split("_")[0]})
                      <div className="lh-sub">
                        <span
                          className={`volbase-${currentPair
                            ?.split("_")
                            ?.join("")}`}
                        >
                          0
                        </span>
                        <span> {currentPair?.split("_")[0]}</span>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="display-1" style={{ gap: "20px" }}>

                  <div
                    onClick={toggleDrawerLayout(true)}
                    className="cursor"
                    style={{ display: !matchesXL && "none" }}
                  >
                    <M2 />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        {!mobilemd && (
          <Grid container>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <div className="display-2  mobile-h">
                Candle Stick
                <div onClick={handleCandle}>
                  <CandlestickChartIcon sx={{ fontSize: "22px !important" }} />
                </div>
              </div>

              <Collapse
                in={candle}
                timeout="auto"
                unmountOnExit
                className="c-stick-cp"
              >
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }}>
                    <Tradeview pair={currentPair} />
                  </ListItemButton>
                </List>
              </Collapse>
            </Grid>
            <Grid xs={6} sm={6} md={12} lg={12} xl={12} className="">
              <div className="mobile-h">Order Book</div>
              <OrderBook />
            </Grid>
            <Grid xs={6} sm={6} md={12} lg={12} xl={12} className="">
              <div className="mobile-h">Place Order</div>
              <PlaceOrder />
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12} className="">
              <Box>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable auto tabs example"
                  className="mobile-tab-trade"
                >
                  <Tab label={`Current Orders(${currentOrders})`} />
                  <Tab label="Order History" />
                  <Tab label="Trade History" />
                  <Tab label="Redemption History" />
                  <Tab label="Asset OverView" />
                </Tabs>
                <CustomTabPanel value={value} index={0}>
                  <Currentorders />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <Orderhistory />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <Tradehistorytab />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                  <Subscription />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={4}>
                  <Assetview />
                </CustomTabPanel>
              </Box>
            </Grid>
          </Grid>
        )}
        {mobilemd && (
          <div className="main-layout">
            <div ref={containerRef} className=" ">
              <Layout
                model={model}
                factory={factory}
                onAction={handleLayoutAction}
                tabSetEnableMaximize={false}
              />
            </div>
          </div>
        )}

        <Modal
          open={openCoinPair}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
          className="modal-box-cnt"
        >
          <Slide in={openCoinPair} direction="right">
            <Box sx={{ ...style }} className="modal-trade">
              <div className="display-2">
                <div class="group">
                  <svg
                    viewBox="0 0 24 24"
                    class="search-icon"
                  >
                    <g>
                      <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
                    </g>
                  </svg>

                  <input
                    onChange={(e) => handleSearch(e.target.value)}
                    id="query"
                    class="input"
                    type="search"
                    placeholder="Search..."
                    name="searchbar"
                  />
                </div>
                <div className="text-right display-1">
                  <HighlightOffIcon
                    sx={{ fill: "var(--clr-font)", cursor: "pointer" }}
                    onClick={() => {
                      handleCloseCoinPair();
                      handleSidebarUnsubscribe();
                    }}
                  />
                </div>
              </div>
              {marketData}
            </Box>
          </Slide>
        </Modal>
      </Box>
    </div>
  );
};

export default Flexlayout;
